import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Stethoscope, Menu, X, Languages } from "lucide-react";
import { Button } from "./ui/button";
import { useLang } from "../context/LanguageContext";

const links = [
  { to: "/", key: "nav.home" },
  { to: "/services", key: "nav.services" },
  { to: "/doctors", key: "nav.doctors" },
  { to: "/about", key: "nav.about" },
  { to: "/contact", key: "nav.contact" },
  { to: "/track", key: "nav.track" },
];

export const Navbar = () => {
  const { lang, toggle, t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-full bg-primary flex items-center justify-center">
            <Stethoscope className="w-5 h-5 text-white" />
          </span>
          <span className="font-heading font-semibold text-lg text-slate-900">Doktor<span className="text-emerald-600">Ke</span>Rumah</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.key.split(".")[1]}`}
              className={({ isActive }) => `px-4 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? "bg-primary/10 text-primary" : "text-slate-600 hover:text-primary"}`}>
              {t(l.key)}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <button onClick={toggle} data-testid="lang-toggle" className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-200 text-sm font-medium text-slate-600 hover:border-primary hover:text-primary transition-colors">
            <Languages className="w-4 h-4" /> {lang === "en" ? "BM" : "EN"}
          </button>
          <Button asChild data-testid="nav-book-btn" className="rounded-full px-6">
            <Link to="/booking">{t("nav.book")}</Link>
          </Button>
        </div>
        <button className="lg:hidden p-2" data-testid="mobile-menu-btn" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-4 py-4 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block px-4 py-2.5 rounded-xl text-slate-700 font-medium hover:bg-slate-50">
              {t(l.key)}
            </NavLink>
          ))}
          <div className="flex items-center gap-3 pt-3">
            <button onClick={toggle} data-testid="lang-toggle-mobile" className="flex items-center gap-1.5 px-4 py-2 rounded-full border border-slate-200 text-sm font-medium">
              <Languages className="w-4 h-4" /> {lang === "en" ? "BM" : "EN"}
            </button>
            <Button asChild className="rounded-full flex-1">
              <Link to="/booking" onClick={() => setOpen(false)}>{t("nav.book")}</Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
